var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.384 23.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rolweerstand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.134 11.666l.966-.966c-1.043-1.825-3.567-3.6-5.2-4.623a11.883 11.883 0 0 0-1.532-.962l-.93 1.771c7.294 3.83 6.182 14.995 6.17 15.107l-.011.1.009.1a2.689 2.689 0 0 1-.494 1.744 1.676 1.676 0 0 1-1.31.466 1.9 1.9 0 0 1-1.429-.491 2.5 2.5 0 0 1-.573-1.612v-6.2c0-1.856-1.881-2.729-3.7-2.789v-6.811a1.43 1.43 0 0 0-1.4-1.4h-9.8a1.367 1.367 0 0 0-1.4 1.4v19.6h-1.2v2.4h15v-2.4h-1.2v-10.789c.521.042 1.7.229 1.7.789v6.167a4.43 4.43 0 0 0 1.126 3.025 3.834 3.834 0 0 0 2.874 1.108 3.61 3.61 0 0 0 2.786-1.118 4.529 4.529 0 0 0 1.014-3.165 23.8 23.8 0 0 0-1.466-10.451zm-9.734 1.534h-9.3v-6.5h9.3v6.5z",
    transform: "translate(-7.3 -5.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriction);
export default __webpack_public_path__ + "static/media/friction.9cf49a5a62e91155ac6c0c5840efcaba.svg";
export { ForwardRef as ReactComponent };